var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-1h40v40H-5z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2,
    cy: 13.6,
    stroke: "#80959D",
    rx: 13.2,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 13.2,
    r: 9.2,
    stroke: "#80959D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 13.2,
    r: 5.2,
    stroke: "#80959D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.2,
    d: "M17.42 29.787l-3.82 3.911V12.8L28 27.94h-5.44l2.21 5.045-5.222 2.215z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomer);
export default __webpack_public_path__ + "static/media/new-customer.e8183c5a355056bcab68ce25ad9d34ab.svg";
export { ForwardRef as ReactComponent };